import * as React from 'react'
import { memo } from 'react'
const SvgChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 7">
    <path d="M6 3.5 0 7V0Z" />
  </svg>
)
const Memo = memo(SvgChevronRight)
export default Memo
